// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"Modal_Dialog__3In5b","titleWrapper":"Modal_titleWrapper__dT84L","dialogBody":"Modal_dialogBody__M4L7o"};